// extracted by mini-css-extract-plugin
module.exports = {"button":"header-button_button__1aaiy","text":"header-button_text__3N5vQ","arrow":"header-button_arrow__3fzkb","arrowUp":"header-button_arrowUp__29mO5"};